var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.col.type,{tag:"component",attrs:{"row":_vm.row,"data":_vm.row[_vm.col.colId],"col":_vm.col},on:{"click":_vm.clickHandler}})}
var staticRenderFns = []

export { render, staticRenderFns }